/* eslint-disable */
import { UAParser } from 'ua-parser-js';

const parser = new UAParser(navigator.userAgent);

export default parser.getResult();
